import actions from '../../actionTypes';

export default statusSummary => {
  return {
    type: actions.SET_STATUS_SUMMARY,
    statusSummary
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/setStatusSummary.js